// extracted by mini-css-extract-plugin
export var intro = "intro-module--intro--soq61";
export var title = "intro-module--title--XyWVw";
export var description = "intro-module--description--3dd62";